import {AccountTypeEntityModel} from "../../account-type-entity.model";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {Component} from "@angular/core";

@Component({
    selector: "wbo-account-type-edit-description",
    templateUrl: "./account-type-edit-description.component.html"
})
export class AccountTypeEditDescriptionComponent {
    constructor(public model: AccountTypeEntityModel, public editService: EditService) {
    }
}
